<div viewEdit="initialState" #viewEdit="viewEdit">
    <div class="view view-edit-show">
        <img src={{imageUrl}} alt="banner image" style="width: 100px;">
        <div style="position: absolute; top: 0;width: inherit">
            <div style="display: flex;flex-direction: row;">
                <span style="flex:1; display:flex;justify-content: end;">
                    <nb-actions>
                        <nb-action icon="edit-outline" (click)="viewEdit.toggle()"  title="Edit Image"></nb-action>
                    </nb-actions>
                </span>
            </div>
        </div>
    </div>
    <div class="edit view-edit-hide">
        <h6>
            Upload Image
        </h6>
        <form [formGroup]="form">
            <input class="form-control" formControlName="uploadedFile" type="file" name="uploadedFile" id="uploadedFile" (change)="uploadFile($event)" >
        </form>
        <ng-container *ngIf="imageLoaded">
            <img id="blah" [src]="uploadImageSrc || 'http://placehold.it/180'" alt="your image" style="width:100%"/>
        </ng-container>
        <div style="display:flex;flex-direction: row;padding: 0.5rem 1rem;">
            <span>&nbsp;</span>
            <div style="flex:1;display:flex;justify-content:end">
                <nb-actions>
                    <nb-action icon="close-outline" (click)="viewEdit.toggle()" title="Edit Name"></nb-action>
                    <nb-action icon="checkmark-outline" (click)="submit()" title="Submit Name"></nb-action>
                </nb-actions>
            </div>
        </div>
    </div>
</div>
